<div class="container footer-margin">
  <h1>CREDITS</h1>

  <div class="">
    <a href="https://www.freepik.com/vectors/technology" rel="noopener noreferrer" target="_blank"><span
      class="color-black">Technology vector created by macrovector - </span>www.freepik.com
    </a>
  </div>
</div>
